import { Discount } from './discount';
import { Package } from './package';

export class OrderSummaryItem {
  constructor(data) {
    this.amount = data.amount;
    this.discountCode = data.discountCode;
    this.discountCustomAmount = data.discountCustomAmount;
    this.discountCustomAmountAlcohol = data.discountCustomAmountAlcohol;
    this.discountCustomAmountCert = data.discountCustomAmountCert;
    this.discountCustomAmountAllergen = data.discountCustomAmountAllergen;

    /** @type {Package} */
    this.package = data.package;
    this.packageId = data.packageId;
    this.price = data.price;
    this.quantity = data.quantity;
    this.stateCode = data.stateCode;

    /** @type {boolean} Free Food Handler Card line added for a Premium Food Manager package. */
    this.isFreeFoodHandlerCard = data.isFreeFoodHandlerCard ?? false;
  }
}

export class OrderSummary {
  constructor(data) {
    this.total = data.total;

    /** @type {OrderSummaryItem[]} */
    this.items = data.items;

    /** @type {Discount[]} */
    this.discounts = data.discounts;
  }
}
